package one.healthium.loco

import androidx.compose.runtime.Composable
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.getString
import org.jetbrains.compose.resources.stringResource

sealed interface LString {

    data class Text(val value: String) : LString

    data class Resource(val value: StringResource, val args: List<Any>) : LString {
        override fun toString(): String {
            return "Resource(value=${value.key}, args=$args)"
        }
    }

}

fun String.asLString(): LString {
    return LString.Text(this)
}

fun StringResource.asLString(vararg args: Any): LString {
    return LString.Resource(this, args.asList())
}

@Composable
fun LString.resolve(): String {
    return when (this) {
        is LString.Text -> this.value
        is LString.Resource -> stringResource(this.value, *this.args.toTypedArray())
    }
}

suspend fun LString.resolveAsync(): String {
    return when (this) {
        is LString.Text -> this.value
        is LString.Resource -> getString(this.value, *this.args.toTypedArray())
    }
}